import { type VariantProps, cva, cx } from "class-variance-authority";
import type { ComponentProps } from "react";

import { Color } from "@whitecircle/graphql/graphql";

const variants = cva("overflow-visible", {
	variants: {
		size: {
			small: "w-1 h-1",
			default: "w-2 h-2",
		},
		color: {
			[Color.Blue]: "text-blue",
			[Color.Pink]: "text-pink",
			[Color.Purple]: "text-purple",
			[Color.Gray]: "text-grey",
			[Color.Yellow]: "text-yellow",
			[Color.Red]: "text-red",
			[Color.Orange]: "text-orange",
			[Color.Green]: "text-green",
			[Color.Cyan]: "text-cyan",
			[Color.White]: "text-white",
		},
	},
});

export function Circle({
	color,
	size,
	className,
	...props
}: VariantProps<typeof variants> & ComponentProps<"circle">) {
	return (
		<circle
			{...props}
			stroke="currentColor"
			fill="currentColor"
			r="1"
			vectorEffect="non-scaling-stroke"
			filter="url(#dot)"
			className={cx(variants({ color, size, className }))}
		/>
	);
}

export function Dot({
	color,
	size,
	className,
	...props
}: VariantProps<typeof variants> & ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			className={variants({ color, size, className })}
			{...props}
		>
			<circle cx={12} cy={12} r={12} fill="currentColor" filter="url(#dot)" />
		</svg>
	);
}

export function AnimatedDot({
	color,
	size,
	className,
	...props
}: VariantProps<typeof variants> & ComponentProps<"svg">) {
	return (
		<svg
			viewBox="0 0 32 32"
			width="32"
			height="32"
			style={{ overflow: "visible" }}
			className={variants({ color, size, className })}
			{...props}
		>
			<circle
				cx="16"
				cy="16"
				r="16"
				fill="currentColor"
				filter="url(#glow)"
				className="animate-blink origin-center"
			/>
			<circle cx="16" cy="16" r="16" fill="currentColor" filter="url(#dot)" />
		</svg>
	);
}
